var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.9e847f31080f57baaee41355ace4779c.svg#c';
                    var viewUrl = 'sprites.9e847f31080f57baaee41355ace4779c.svg#view-c';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };